import React from 'react'
import styled from 'styled-components'
import { Box } from 'rebass/styled-components'

const NavigationItem = styled(Box)`
    align-self: stretch;
    line-height: 1.4em;

    &:first-child > a {
        padding-left: 0;
    }
    &:last-child > a {
        padding-right: 0;
        &:after {
            display: none;
        }
    }
    &:hover > a,
    .active {
        font-weight: bold;
    }
    .active + .subnav-container,
    &:hover > a + .subnav-container {
        display: block;
    }
    &:hover > a + .subnav-container {
        z-index: 2;
    }
`

const HeaderLink = ({ children }) => {
    return <NavigationItem>{children}</NavigationItem>
}

export default HeaderLink
